import { render, staticRenderFns } from "./AddDialogHeader.vue?vue&type=template&id=ec86b908"
import script from "./AddDialogHeader.vue?vue&type=script&lang=js"
export * from "./AddDialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports